export default __webpack_public_path__ + "static/media/crac2.c829cb31.svg";